import { MEDIA, NAV_LINKS, CLINIC } from "@/lib/data";
import { Facebook, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-slate-900 text-slate-200 pt-16 lg:pt-20 pb-8 overflow-hidden"
    >
      <div className="absolute -top-32 -right-32 w-[28rem] h-[28rem] rounded-full bg-brand-blue/15 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-32 w-[24rem] h-[24rem] rounded-full bg-brand-aqua/10 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 mb-12 pb-12 border-b border-white/10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <div className="bg-white rounded-2xl p-2.5">
                <img src={MEDIA.logo} alt="Marimar Clinic" className="h-10 w-auto" />
              </div>
              <div>
                <p className="font-display text-[20px] font-medium text-white">Marimar Clinic</p>
                <p className="text-[12px] uppercase tracking-[0.2em] text-brand-blueLight">
                  Stomatologie · Fizio · Kineto
                </p>
              </div>
            </div>
            <p className="text-[15px] leading-relaxed text-slate-400 max-w-md mb-6">
              Clinică medicală premium din București, Sector 2 — unde profesionalismul,
              tehnologia și grija pentru pacient se întâlnesc.
            </p>
            <div className="space-y-2.5 text-[14px] text-slate-300">
              <p className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-brand-blueLight shrink-0" /> {CLINIC.address}</p>
              <p className="flex items-center gap-2"><Phone className="w-4 h-4 text-brand-blueLight" /> Dental: {CLINIC.dental.phone}</p>
              <p className="flex items-center gap-2"><Phone className="w-4 h-4 text-brand-aqua" /> Fizio: {CLINIC.fizio.phone}</p>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="font-display text-[15px] font-medium text-white mb-5">Navigare</p>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-[14px] text-slate-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="font-display text-[15px] font-medium text-white mb-5">Email & Social</p>
            <div className="space-y-3 mb-6">
              <a href={`mailto:${CLINIC.dental.emails[0]}`} className="flex items-center gap-2 text-[14px] text-slate-400 hover:text-white transition-colors">
                <Mail className="w-4 h-4" />
                {CLINIC.dental.emails[0]}
              </a>
              <a href={`mailto:${CLINIC.dental.emails[1]}`} className="flex items-center gap-2 text-[14px] text-slate-400 hover:text-white transition-colors">
                <Mail className="w-4 h-4" />
                {CLINIC.dental.emails[1]}
              </a>
              <a href={`mailto:${CLINIC.fizio.emails[0]}`} className="flex items-center gap-2 text-[14px] text-slate-400 hover:text-white transition-colors">
                <Mail className="w-4 h-4" />
                {CLINIC.fizio.emails[0]}
              </a>
            </div>
            <div className="flex gap-3">
              <a
                href={CLINIC.dental.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 text-[13px] transition-colors"
                data-testid="footer-fb-dental"
              >
                <Facebook className="w-4 h-4 text-brand-blueLight" />
                Dental
              </a>
              <a
                href={CLINIC.fizio.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 text-[13px] transition-colors"
                data-testid="footer-fb-fizio"
              >
                <Facebook className="w-4 h-4 text-brand-aqua" />
                Fizio
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-4 justify-between items-center text-[13px] text-slate-500">
          <p>© 2026 Marimar Clinic. Toate drepturile rezervate.</p>
          <p className="flex items-center gap-1.5">
            Stomatologie <span className="text-slate-600">•</span> Fizioterapie <span className="text-slate-600">•</span> Kinetoterapie
          </p>
        </div>
      </div>
    </footer>
  );
}
